import ARI from '../../images/ARI.png';
import ATL from '../../images/ATL.png';
import BAL from '../../images/BAL.png';
import BUF from '../../images/BUF.png';
import CAR from '../../images/CAR.png';
import CHI from '../../images/CHI.png';
import CIN from '../../images/CIN.png';
import CLE from '../../images/CLE.png';
import DAL from '../../images/DAL.png';
import DEN from '../../images/DEN.png';
import DET from '../../images/DET.png';
import GB from '../../images/GB.png';
import HOU from '../../images/HOU.png';
import IND from '../../images/IND.png';
import JAX from '../../images/JAX.png';
import KC from '../../images/KC.png';
import LV from '../../images/LV.png';
import LAC from '../../images/LAC.png';
import LAR from '../../images/LAR.png';
import MIA from '../../images/MIA.png';
import MIN from '../../images/MIN.png';
import NE from '../../images/NE.png';
import NO from '../../images/NO.png';
import NYG from '../../images/NYG.png';
import NYJ from '../../images/NYJ.png';
import PHI from '../../images/PHI.png';
import PIT from '../../images/PIT.png';
import SEA from '../../images/SEA.png';
import SF from '../../images/SF.png';
import TB from '../../images/TB.png';
import TEN from '../../images/TEN.png';
import WAS from '../../images/WAS.png';

const teamLogos = {
    ARI,
    ATL,
    BAL,
    BUF,
    CAR,
    CHI,
    CIN,
    CLE,
    DAL,
    DEN,
    DET,
    GB,
    HOU,
    IND,
    JAX,
    KC,
    LV,
    LAC,
    LAR,
    MIA,
    MIN,
    NE,
    NO,
    NYG,
    NYJ,
    PHI,
    PIT,
    SEA,
    SF,
    TB,
    TEN,
    WAS,
};

export default teamLogos;
